import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMouse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.0518 9.99593L20.5749 15.5159L17.9175 18.1704L12.3975 12.6504L8.84277 19.2L2.40186 0L21.5988 6.43817L15.0518 9.99593Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgMouse;
